export const loadingTeamTypesSelector = state => state.teamReducer.loadingTeamTypes;

export const teamListSelector = state => state.teamReducer.teamList;

export const loadingTeamsSelector = state => state.teamReducer.loadingTeams;

export const teamsFetchStatusSelector = state => state.teamReducer.teamsFetchStatus;
